module.exports = __webpack_public_path__ + "img/moldova.d25dc7b6.png";